import React, { useEffect, useState } from 'react';
import { useOutletContext, useNavigate } from 'react-router-dom';
import { Box, ClickAwayListener } from '@mui/material';
import { BarGraph, Card, Icon, Loader, Typography, SideBar } from '@tucar/pit-stop';
import { useReactiveVar, useLazyQuery } from '@apollo/client';
import tucarIcon from '../../../../../public/images/appIcons/icon-512x512.png';
import { useAuthParams } from '../../../../hooks';
import { revokeToken } from '../../../../api/auth';
import { getAuthStore, getDriverStore, logout, getRefreshToken } from '../../../../graphql/store';
import { azulTucar } from '../../../../themes/variants/TucarColors';
import GET_DRIVER_BILLDAY_LIMIT from '../../../../graphql/querys/driver/getBillDays';
import NameAndTurnBox from './sections/NameAndTurn';
// import ProfitsCard from './sections/ProfitsCard';
import PressIconButton from '../../../../components/buttons/PressIconButton';
import { formatData, backgroundStyle, basicSectionsSideBar } from './auxFunctions';
import PaymentDebtCard from './sections/PaymentDebtCard';
// import ManageButtons from './sections/ManageButtons';
import RejectedScreen from './screens/RejectedScreen';
import SleepScreen from './screens/SleepingScreen';
import ReturnScreen from './screens/ReturnScreen';
import TopBarDashboard from './sections/TopBarDashboard';
// import ShortCuts from './sections/ShortCuts';
import { getStartOfWeek, getEndOfWeek } from '../../../../helpers/dateFormat';
import TermsAndConditionModal from '../../../../components/info/termsAndCondition';

// import { useSalesforceContext } from '../../../../contexts/SalesforceContext';
const PLAY_URL = 'https://play.google.com/store/apps/details?id=app.tucar.driver.twa';
const APPLE_URL = 'https://apps.apple.com/cl/app/tucar/id6749870114';

const NewDashboard = () => {
  const navigate = useNavigate();

  const [handlePageChange] = useOutletContext();
  const [openSide, setOpenSide] = useState(false);
  const [currentData, setCurrentData] = useState({
    totalExpenses: 0,
    totalCollections: 0,
    totalGaining: 0,
    totalCash: 0,
    kmTotal: 0,
    kmUber: 0,
    uberPercentage: 0,
    kmByDay: [],
  });
  const {
    data: { uid, firstname, lastname },
  } = useReactiveVar(getAuthStore);
  const { rent, status, photo } = useReactiveVar(getDriverStore);
  const { getLogoutUrl } = useAuthParams();
  // const { openSalesforceChat } = useSalesforceContext();

  const locallyLogout = () => {
    logout();
    window.location.href = getLogoutUrl();
  };

  // eslint-disable-next-line no-unused-vars
  const onClickLogoutHandler = async () => {
    const refreshToken = getRefreshToken();
    const { accessToken } = getAuthStore();
    await revokeToken(accessToken, { onError: locallyLogout });
    await revokeToken(refreshToken, {
      onError: locallyLogout,
      onSuccess: locallyLogout,
    });
  };

  const sectionsSideBar = basicSectionsSideBar(navigate);

  const [paymentData, setPaymentData] = useState({});
  // eslint-disable-next-line no-unused-vars
  const [openDoorShow, setOpenDoorShow] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());

  const [getBillDays, { loading, data }] = useLazyQuery(GET_DRIVER_BILLDAY_LIMIT.query, {
    ...GET_DRIVER_BILLDAY_LIMIT.policies,
    variables: {
      uid,
      initialDatetime: getStartOfWeek(selectedDate),
      finalDatetime: getEndOfWeek(selectedDate),
      labelId: 'REMOTE_CONTROL_DOORS',
      carId: rent?.carId || '',
      skipCarStatus: !rent?.carId,
    },
  });

  useEffect(() => {
    handlePageChange(false, true);
    getBillDays();
  }, []);

  useEffect(() => {
    getBillDays({
      initialDatetime: getStartOfWeek(selectedDate),
      finalDatetime: getEndOfWeek(selectedDate),
    });
  }, [selectedDate]);

  useEffect(() => {
    if (data && data?.getDriverBillDaysLimitDates) {
      const formatedData = formatData(data.getDriverBillDaysLimitDates);
      setCurrentData(formatedData);
    }
    if (data && data?.getLabel && data?.carStatus) {
      setOpenDoorShow(data.getLabel.elements.includes(rent?.carId));
    }
    if (data && data?.paymentArray && data?.paymentArray.length > 0) {
      setPaymentData(data.paymentArray[0]);
    }
  }, [loading, data]);

  if (loading) {
    return (
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <Loader size={32} pointRadio="4px" />
      </Box>
    );
  }

  return (
    <>
      <TermsAndConditionModal />
      <ReturnScreen />
      <SleepScreen />
      <RejectedScreen />
      <ClickAwayListener
        mouseEvent="onMouseDown"
        onClickAway={() => (openSide ? setOpenSide(false) : null)}
      >
        <Box>
          <SideBar
            onClickPhoto={() => navigate('/app/v2/profile', { replace: true })}
            userPhoto={photo}
            userName={`${firstname} ${lastname}`}
            sections={sectionsSideBar}
            /* bottomContent={bottomSideBar({
              onFaqClick: () => navigate('/app/v2/faq'),
              onContactClick: openSalesforceChat,
              onLogoutClick: onClickLogoutHandler,
            })} */
            open={openSide}
            variant="mobile"
          />
        </Box>
      </ClickAwayListener>
      <Box sx={backgroundStyle(status.status === 'rent')}>
        <TopBarDashboard
          setSelectedDate={setSelectedDate}
          selectedDate={selectedDate}
          setOpenSide={setOpenSide}
        />
        <NameAndTurnBox />
        <Box sx={{ marginTop: '35px', display: 'flex', justifyContent: 'center' }}>
          <PaymentDebtCard data={paymentData} />
        </Box>

        <Card
          style={{
            padding: '12px 16px',
            marginTop: '20px',
            gap: '20px',
            flexDirection: 'row',
            alignItems: 'center',
            cursor: 'pointer',
          }}
          onClick={() => navigate('/app/v2/liquidations')}
        >
          <PressIconButton>
            <Icon name="libraryBooksFilled" color={azulTucar} size="36px" />
          </PressIconButton>
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
            <Typography color="#5B5D71" style={{ fontSize: '16px', fontWeight: 600 }}>
              Ver liquidaciones
            </Typography>
          </Box>
          <Icon name="chevronRightRounded" color="#5B5D71" size="24px" />
        </Card>

        <Card
          style={{
            padding: '0',
            marginTop: '20px',
            overflow: 'hidden',
            background: 'linear-gradient(135deg, #667eea 0%, #1F89FF 100%)',
            border: 'none',
          }}
        >
          <Box
            sx={{
              padding: '24px 20px',
              display: 'flex',
              flexDirection: 'column',
              gap: '20px',
            }}
          >
            <Box
              sx={{
                justifyContent: 'space-between',
                gap: '16px',
                display: 'grid',
                gridTemplateColumns: { xs: 'auto', sm: 'auto 1fr' },
              }}
            >
              <Box
                sx={{
                  borderRadius: '12px',
                  padding: '2px',
                  backgroundColor: '#FFFFFF',
                  display: 'flex',
                  width: 'fit-content',
                  height: 'fit-content',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                }}
              >
                <img
                  src={tucarIcon}
                  alt="Tucar App"
                  style={{ width: '48px', height: '48px', borderRadius: '8px' }}
                />
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, padding: '2px' }}>
                <Typography
                  style={{
                    fontSize: '20px',
                    fontWeight: 700,
                    color: '#FFFFFF',
                    marginBottom: '4px',
                  }}
                >
                  Descarga la nueva aplicación
                </Typography>
                <Typography
                  style={{
                    fontSize: '14px',
                    fontWeight: 400,
                    color: '#FFFFFF',
                    opacity: 0.9,
                  }}
                >
                  Experiencia mejorada y más rápida
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '10px',
                  marginTop: '4px',
                  gridColumn: { xs: '1', sm: '2' },
                }}
              >
                <Box
                  component="a"
                  href={PLAY_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'transparent',
                    borderRadius: '10px',
                    textDecoration: 'none',
                    cursor: 'pointer',
                    transition: 'transform 0.2s',
                    '&:hover': {
                      transform: 'scale(1.02)',
                    },
                  }}
                >
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                    alt="Get it on Google Play"
                    style={{ height: '45px', width: 'auto' }}
                  />
                </Box>
                <Box
                  component="a"
                  href={APPLE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'transparent',
                    borderRadius: '10px',
                    textDecoration: 'none',
                    cursor: 'pointer',
                    transition: 'transform 0.2s',
                    '&:hover': {
                      transform: 'scale(1.02)',
                    },
                  }}
                >
                  <img
                    src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                    alt="Download on the App Store"
                    style={{ height: '45px', width: 'auto' }}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Card>

        {/* <ManageButtons openDoorShow={openDoorShow} /> 
                <ProfitsCard data={currentData} />
                <ShortCuts /> */}
        {/* km uber % card  
        <Card
          style={{
            padding: '12px 16px',
            marginTop: '30px',
            gap: '20px',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <PressIconButton>
            <Icon name="equalizerRounded" color="#95D31C" size="36px" />
          </PressIconButton>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography color="#5B5D71" style={{ fontSize: '15px', fontWeight: 600 }}>
              El {currentData.uberPercentage}% de tus kilómetros
            </Typography>
            <Typography color="#5B5D71" style={{ fontSize: '14px', fontWeight: 500 }}>
              Han sido en viajes de Uber
            </Typography>
          </Box>
        </Card>
        {/* km total trips  
        <Box
          sx={{
            marginTop: '34px',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Typography
            color={azulTucar}
            style={{
              fontSize: '24px',
              fontWeight: 600,
              textAlign: 'center',
            }}
          >
            {currentData.kmTotal
              .toFixed(0)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, '.')}{' '}
            KM
          </Typography>
        </Box>
        {/* km graph trips  */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            paddingBottom: '40px',
          }}
        >
          {currentData.kmByDay.length > 0 && currentData.kmTotal > 0 && (
            <BarGraph
              data={currentData.kmByDay}
              step={5}
              barWidth="18px"
              gap="20px"
              total={currentData.maxKm}
              maxWidth="max-content"
              maxHeight="250px"
              finalLabelType=" km"
            />
          )}
        </Box>
      </Box>
    </>
  );
};

export default NewDashboard;
